import { schema } from 'normalizr';

const accountScheme = new schema.Entity('account');

export default accountScheme;
